import ENDPOINTS from 'api/endpoints';
import { doPut } from 'api/request';
import type { AsrKeyphrase, PatchAsrCorrection } from 'api/types';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { AsrCorrectionsResponse } from './types';

export const updateAssistantAsrCorrections = ({
  accountId,
  projectId,
  asrCorrections,
}: {
  accountId: string;
  projectId: string;
  asrCorrections: PatchAsrCorrection[];
}) => {
  return doPut<AsrCorrectionsResponse>(
    generateNextPath(ENDPOINTS.TRANSCRIPT_CORRECTIONS, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    { asr_corrections: asrCorrections },
    { version: 'v2' },
  );
};

export const updateAssistantAsrKeyphrases = ({
  accountId,
  projectId,
  asrKeyphrases,
}: {
  accountId: string;
  projectId: string;
  asrKeyphrases: AsrKeyphrase[];
}) => {
  return doPut<AsrCorrectionsResponse>(
    generateNextPath(ENDPOINTS.KEYPHRASE_BOOSTING, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    { asr_keyphrases: asrKeyphrases },
    { version: 'v2' },
  );
};
